import gql from 'graphql-tag';

const DELETE_SLA_CONFIG = gql`
  mutation deleteSlaConfig($where: SlaConfigWhereUniqueInput!) {
    deleteSlaConfig(where: $where) {
      id
    }
  }
`;

export default DELETE_SLA_CONFIG;
